module.exports = __webpack_public_path__ + "static/img/wayfinding-sign-anodized-aluminum.7b8900a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/wayfinding/wayfinding-sign-anodized-aluminum.jpg
// module id = 1048
// module chunks = 0